import useSWR from "swr";
import axios from "axios";

function useDesignAndEngineeringProjectClients() {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/design-and-engineering-projects/clients`,
  ], async (url) => {
    const { data: clients } = await axios.get(url);

    return { clients };
  });
}

export default useDesignAndEngineeringProjectClients;
